module.exports = __webpack_public_path__ + "static/no-easy-day-fd1f5199449ef6b348da921cf55cae2d.jpg";